// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"3de72882","356":"de103568"}[chunkId] + ".chunk.js";
};